import { Button, Group, Text } from '@mantine/core';
import ModalPopupComponent from 'components/ModalPopup';
import React from 'react';
import { HiOutlineTrash } from 'react-icons/hi';

interface ModalDeleteProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  activityName?: string;
  description?: string;
  title?: string;
  labelConfirm?: string;
  labelCancel?: string;
}

const ModalDelete: React.FC<ModalDeleteProps> = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
  activityName,
  title = 'Delete Activity',
  description,
  labelCancel = 'Cancel',
  labelConfirm = 'Delete Activity'
}) => {
  return (
    <ModalPopupComponent title={title} size='lg' opened={opened} close={onClose}>
      {description ? (
        <Text>{description}</Text>
      ) : (
        <Text>
          Are you sure to delete this activity <strong>{activityName}</strong>?
        </Text>
      )}
      <Group justify='flex-end' mt={'md'}>
        <Button variant='outline' onClick={onClose} disabled={isLoading}>
          {labelCancel}
        </Button>
        <Button loading={isLoading} disabled={isLoading} onClick={onConfirm} color={'destructive'}>
          <HiOutlineTrash />
          {labelConfirm}
        </Button>
      </Group>
    </ModalPopupComponent>
  );
};

export default ModalDelete;
